module.exports = __webpack_public_path__ + "static/media/1_pl.ca373056.png";